__turbopack_context__.v({
  "center": "Home-module__g21JLG__center",
  "center_img": "Home-module__g21JLG__center_img",
  "flex": "Home-module__g21JLG__flex",
  "footer": "Home-module__g21JLG__footer",
  "grey": "Home-module__g21JLG__grey",
  "grid": "Home-module__g21JLG__grid",
  "grid_img": "Home-module__g21JLG__grid_img",
  "main": "Home-module__g21JLG__main",
  "text": "Home-module__g21JLG__text",
  "title": "Home-module__g21JLG__title",
  "toptitle": "Home-module__g21JLG__toptitle",
});
